import React, { useContext } from "react";
import { Context as NavigationContext } from "./Context";
import { ContextProvider } from "@wdpr/groot-components";

const GrootContextBridge = ({ children }) => {
	const navContextValue = useContext(NavigationContext);

	return (
		<ContextProvider value={navContextValue}>
			{children}
		</ContextProvider>
	);
};

export default GrootContextBridge;
